import { render, staticRenderFns } from "./SalesProductGraph.vue?vue&type=template&id=213534bd&"
import script from "./SalesProductGraph.vue?vue&type=script&lang=js&"
export * from "./SalesProductGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports